import { StyleSheet } from 'react-native'

import { Metrics } from '../../Themes'

export default StyleSheet.create({
  container: theme => ({
    width: Metrics.paymentOptionWidth,
    minHeight: 130,
    margin: Metrics.paymentOptionSpacing,
    marginBottom: 20,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: theme.colors.borderColorThree,
    backgroundColor: theme.colors.cardBackgroundColor,
    alignItems: 'center',
  }),
  title: {
    flexGrow: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    marginBottom: 8,
  },
})
